import { Component } from '@angular/core';
import { AccountSettingsNavComponent } from './account-settings-nav.component';

@Component({
  selector: 'app-account-menu-page',
  standalone: true,
  imports: [AccountSettingsNavComponent],
  templateUrl: './account-menu-page.component.html',
  styleUrls: ['./account-menu-page.component.scss']
})
export class AccountMenuPageComponent {}
